import TYPES from './types';
import { get } from 'utils/api';

export const getLogReportsGraph = params => dispatch => {
  const { label, ...rest } = params;
  dispatch({ type: TYPES.GET_LOG_REPORTS_GRAPH.START });

  return get(`/log-reports-graph`, rest)
    .then(response => {
      dispatch({
        type: TYPES.GET_LOG_REPORTS_GRAPH.SUCCESS,
        payload: { data: response.data, label }
      });
      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.GET_LOG_REPORTS_GRAPH.ERROR, payload: error });
      throw error;
    });
};
